import type { CSSProperties } from 'react';

/** 时 / 分 / 秒 时长片段 */
export type TimerDuration = {
  hours: number;
  minutes: number;
  seconds: number;
};

export type TimerDisplayFormat = 'hms' | 'ms' | 's';

export type TimerStatus = 'idle' | 'running' | 'paused' | 'completed';

export type TimerDurationField = keyof TimerDuration;

/** 倒计时：主显示剩余时间；正计时：主显示已用时间 */
export type TimerMode = 'countDown' | 'countUp';

export const DEFAULT_TIMER_DURATION: TimerDuration = {
  hours: 0,
  minutes: 0,
  seconds: 0,
};

export const DEFAULT_TIMER_MODE: TimerMode = 'countDown';

export type TimerProps = {
  /** 圆形容器直径（px），默认 220 */
  size?: number;
  className?: string;
  style?: CSSProperties;
  /** 初始目标时长，默认 00:00:00 */
  defaultTarget?: TimerDuration;
  /** 计时模式，默认倒计时 */
  defaultMode?: TimerMode;
  /** 会话 id（如画布 block.id），跨 remount 保留计时进度 */
  sessionId?: string;
  /** 进度环外置渲染（画布 block 缩放层外） */
  hideRing?: boolean;
  /** 进度变更（含 rAF 驱动，供外置进度环 imperative 更新） */
  onProgressTick?: (progress: number) => void;
  /** 目标时长变更（块内设置或属性面板同步） */
  onTargetChange?: (next: TimerDuration) => void;
  /** 计时模式变更 */
  onModeChange?: (next: TimerMode) => void;
  /** 计时到达目标时长时回调（仅触发一次） */
  onComplete?: () => void;
};

export type TimerTimeSettingProps = {
  value: TimerDuration;
  onChange: (next: TimerDuration) => void;
  editable: boolean;
};
